import { useEffect } from "react";

const BackButtonHandler = () => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Evita di tornare indietro se il focus è su un input o textarea
      if (
        event.key === "Backspace" &&
        !["INPUT", "TEXTAREA"].includes(document.activeElement.tagName)
      ) {
        event.preventDefault();
        window.history.back(); // Torna alla pagina precedente
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return null;
};

export default BackButtonHandler;
